import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M21 3a1 1 0 0 1 0 2h-3v12a4 4 0 1 1 -2.001 -3.465l.001 -9.535a1 1 0 0 1 1 -1z","key":"svg-0"}],["path",{"d":"M14 5a1 1 0 0 1 -1 1h-10a1 1 0 1 1 0 -2h10a1 1 0 0 1 1 1","key":"svg-1"}],["path",{"d":"M14 9a1 1 0 0 1 -1 1h-10a1 1 0 1 1 0 -2h10a1 1 0 0 1 1 1","key":"svg-2"}],["path",{"d":"M10 13a1 1 0 0 1 -1 1h-6a1 1 0 0 1 0 -2h6a1 1 0 0 1 1 1","key":"svg-3"}]]

const IconPlaylistFilled = createReactComponent('filled', 'playlist-filled', 'PlaylistFilled', __iconNode);

export default IconPlaylistFilled;